import React, { useState, useEffect } from "react";
import Map, { Marker } from "../../Utils/GoogleMap/Map2";
import {
  fetchEstimateData,
  fetchEstimatemegabranch,
} from "../Fetch/fetchBackend";
import NavList from "./NavItems/NavList";
import BulidingPhoto from "../TypePhoto";
import { point, TrueMap } from "../../../StaticResource";
import { ObjFilterHandler, formatFilter } from "../../Utils/Filter/Filter";
const MapContainer = ({ addr, mapCenter }) => {
  const [estimatedata, setEstimateData] = useState([]);
  const [estBranch, setEstBranch] = useState([]);
  const [gmarkers, setGmarkers] = useState([]);
  useEffect(() => {
    fetchEstimateData(mapCenter, setEstimateData);
    fetchEstimatemegabranch(mapCenter, setEstBranch);
  }, [mapCenter]);
  if (estimatedata === [] || estBranch === []) return <></>;
  return (
    <div className="row">
      <div className="col-md-12">
        <div className="g-map map-new" style={{ height: "700px" }}>
          <Map
            id="map"
            options={options(mapCenter)}
            gmarkers={gmarkers}
            mapCenter={mapCenter}
            showCenter={true}
            style={mapStyle}
            showInfoWindow={true}
            addr={addr}
          >
            {estimatedata.map((data, i) => {
              //因為業務邏輯，將db中 B_TYPE_INT = 5 當成 B_TYPE_INT = 6 處理
              //在右方的勾選單上，視為 6(電梯大樓/華廈)
              const category = data.B_TYPE_INT === 5 ? 6 : data.B_TYPE_INT;
              const visible = category === 6 ? true : false;
              return (
                <Marker
                  key={i}
                  lat={data.LATITUDE}
                  lng={data.LONGITUDE}
                  data={data}
                  category={category}
                  title={data.B_TYPE}
                  visible={visible}
                  image={BulidingPhoto(data.B_TYPE_INT)}
                  setInfowindow={true}
                  infoContent={infowindowFormat(data)}
                />
              );
            })}
            {estBranch.map((data, i) => {
              return (
                <Marker
                  key={i}
                  lat={data.latitude}
                  lng={data.longitude}
                  title={data.B_TYPE}
                  data={data}
                  category={0}
                  visible={true}
                  image={BulidingPhoto("branch")}
                  setInfowindow={true}
                  infoContent={branchInfoWindow(data)}
                />
              );
            })}
          </Map>
          <NavList gmarkers={gmarkers} />
        </div>
      </div>
    </div>
  );
};

export default MapContainer;

const mapStyle = {
  width: "100%",
  height: "90%",
  position: "relative",
  overflow: "hidden",
};

const options = (mapCenter) => {
  if (mapCenter) {
    return {
      center: TrueMap
        ? { lat: mapCenter.lat(), lng: mapCenter.lng() }
        : { lat: point.lat, lng: point.lng },
      mapTypeControl: false,
      scaleControl: true,
      zoomControlOptions: {
        position: window.google.maps.ControlPosition.LEFT_BOTTOM,
      },
      fullscreenControlOptions: {
        position: window.google.maps.ControlPosition.LEFT_TOP,
      },
      streetViewControl: false,
      panControl: false,
      zoom: 18,
      //zoom: 16 比例尺為 100 m，地圖全長 2500 m，半徑顯示為 1250 m
      //zoom: 17 比例尺為  50 m，地圖全長 1250 m，半徑顯示為  625 m
      //zoom: 18 比例尺為  20 m，地圖全長  500 m
    };
  }
};

const infowindowFormat = (data) => {
  return (
    '<h3 class="popover-header">' +
    data.B_TYPE +
    '</h3><div class="popover-body"><ul class="reset"><li>單價：' +
    formatFilter(data.UNIT_PRICE_P, "housePrice") +
    "萬元/坪</li><li>總坪數：" +
    data.B_AREA_P +
    "坪</li><li>屋齡：" +
    data.B_AGE +
    "年</li><li>移轉樓層：" +
    data.LEVEL +
    "</li><li>總樓層數：" +
    data.FLOORS +
    "</li><li>交易日期：" +
    data.TRANS_YMD +
    "</li></ul></div>"
  );
};

const branchInfoWindow = (data) => {
  return (
    '<div class=""><div class="arrow"></div><h3 class="popover-header">' +
    data.branch_name +
    '</h3><div class="popover-body"><ul class="reset"><li>Tel：' +
    data.fax +
    "</li></ul></div></div>"
  );
};
